import { render } from "./languagePackage.vue?vue&type=template&id=c9b13886&scoped=true"
import script from "./languagePackage.vue?vue&type=script&lang=js"
export * from "./languagePackage.vue?vue&type=script&lang=js"

import "./language-package.scss?vue&type=style&index=0&id=c9b13886&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b13886"]])

export default __exports__